import { ScientificAnalysisComparatorType, ScientificAnalysisConditionTypeEnum, ScientificAnalysisFieldAdditionalInfo, ScientificAnalysisFilterEntityType, ScientificAnalysisSearchEntityType } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { Nullable } from '@/shared/types/app.types'

export const SCIENTIFIC_ANALYSIS_DEFAULT_GROUP_BY_PARENT_ENTITY_BEHAVIOR: boolean = false
export const SCIENTIFIC_ANALYSIS_CONDITION_TYPE_NONE: string = ''

export enum ScientificAnalysisConditionValidationErrorCode{
    NONE = 0,
    EMPTY = 1,
    FROM_GREATERTHAN_TO = 2
}

export interface ScientificAnalysisComparisonType {
    comparatorType: ScientificAnalysisComparatorType
    conditionType: ScientificAnalysisConditionTypeEnum
    additionalInfo: ScientificAnalysisFieldAdditionalInfo | null
}

export interface ScientificAnalysisCondition {
    value: string | string[],
    valueTo: Nullable<string | string[]>
    comparisonType: ScientificAnalysisComparisonType
    validationErrorCode: ScientificAnalysisConditionValidationErrorCode
    metaInfo: Nullable<string[]>
}

export interface ScientificAnalysisConditionFieldGroup {
    field: string,
    translatedFieldName: string,
    conditions: ScientificAnalysisCondition[]
}

export interface ScientificAnalysisFilter {
    fieldGroups: ScientificAnalysisConditionFieldGroup[]
}

export interface ScientificAnalysisEntityFilters {
    entityType: ScientificAnalysisFilterEntityType,
    groupedByParentEntity: boolean,
    filters: ScientificAnalysisFilter[]
}

export interface ScientificAnalysisSortField {
    field: string,
    direction: string
}

export interface ScientificAnalysis {
    entityFilters: ScientificAnalysisEntityFilters[],
    laboratoryIds: number[],
    searchedEntityType: ScientificAnalysisSearchEntityType | null,
    sort: ScientificAnalysisSortField[],
    version: number
}

export const SCIENTIFIC_ANALYSIS_CURRENT_SCHEMA_VERSION: number = 1
